import Loader from "@components/Loader";

const UnderConstruction = () => {
    
    return (
        <div>
            <Loader active={true} message="Site is under construction!" />
        </div>
    );
};

export default UnderConstruction;